import * as actionTypes from '../actionTypes';

function handleFailure(request, response) {
  return new Promise((resolve, reject) => {
    resolve({
      type: actionTypes.RESPONSE_FAILURE,
      request,
      response,
    });
  });
}

export function handle500(...args) {
  return handleFailure(...args);
}

export function handle502(...args) {
  return handleFailure(...args);
}

export function handle503(...args) {
  return handleFailure(...args);
}

export function handle504(...args) {
  return handleFailure(...args);
}



// WEBPACK FOOTER //
// ./app/javascript/requests/responseHandlers/5xx.js